import { getTokens } from 'tamagui';
import { useBreakpoint } from './useBreakpoint';

/**
 * Hook to determine the horizontal padding for the page based on screen size.
 */
export const usePageHorizontalPadding = (): number => {
  const { isSmallScreen, isMediumScreen } = useBreakpoint();
  const uiTokens = getTokens();

  if (isSmallScreen) {
    return uiTokens.space.$2.val;
  }

  if (isMediumScreen) {
    return uiTokens.space.$4.val;
  }

  return uiTokens.space.$7.val;
};
